import React from 'react';
import {AssignmentModelV3} from 'resources/GeneratedModels/Assignment/AssignmentModel.v3';
import './assignment-content.scss';

interface AssignmentContentProps {
  assignment: AssignmentModelV3
}

const AssignmentContent = ({assignment}: AssignmentContentProps) => {
  const name = assignment.getName();
  const type = assignment.getAssignmentType() === 'assignment' ? 'Assignment' : 'Assessment';

  return (
    <div>
      <div className='assignment-content'>
        <span className='assignment-content-text-primary'>{name}</span>
        <span className='assignment-content-text-secondary'>{type}</span>
      </div>
    </div>
  );
}

export default AssignmentContent;
